import { render } from "./DateFormats.vue?vue&type=template&id=6afdb9a1"
import script from "./DateFormats.vue?vue&type=script&lang=ts"
export * from "./DateFormats.vue?vue&type=script&lang=ts"
script.render = render

export default script